import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from "@angular/forms";

@Component({
  selector: 'sb-cron-expression',
  templateUrl: './cron-expression.component.html',
  styleUrls: ['./cron-expression.component.scss']
})
export class CronExpressionComponent implements OnInit {

  @Input()
  expression: string;

  @Output()
  expressionChange: EventEmitter<string> = new EventEmitter<string>();

  activeTab = 1;

  cronForm: UntypedFormGroup;

  range1To60 = this.stringRange(1, 60);

  range0To59 = this.stringRange(0, 59);

  range1To24 = this.stringRange(1, 24);

  range0To23 = this.stringRange(0, 23);

  range1To7 = this.stringRange(1, 7);

  range1To28 = this.stringRange(1, 28);

  range1To31 = this.stringRange(1, 31);

  range1To5 = this.stringRange(1, 5);

  range1To12 = this.stringRange(1, 12);

  range1To20 = this.stringRange(1, 20);

  range2020To2029 = this.stringRange(2020, 2029);

  dowRange1To7 = [
    { label: 'Sunday', value: '1'},
    { label: 'Monday', value: '2'},
    { label: 'Tuesday', value: '3'},
    { label: 'Wednesday', value: '4'},
    { label: 'Thursday', value: '5'},
    { label: 'Friday', value: '6'},
    { label: 'Saturday', value: '7'},
  ];

  monthRange1To12 = [
    { label: 'January', value: '1'},
    { label: 'February', value: '2'},
    { label: 'March', value: '3'},
    { label: 'April', value: '4'},
    { label: 'May', value: '5'},
    { label: 'June', value: '6'},
    { label: 'July', value: '7'},
    { label: 'August', value: '8'},
    { label: 'September', value: '9'},
    { label: 'October', value: '10'},
    { label: 'November', value: '11'},
    { label: 'December', value: '12'},
  ];

  domRange1To31 = this.range1To31.map(e => { const val = {label: this.daySuffix(e), value: e}; return val; });

  domRange1To5 = this.range1To5.map(e => { const val = {label: this.daySuffix(e), value: e}; return val; });

  cronMinuteSpecificSpecificState: {value: string, checked: boolean}[] = this.range0To59.map(e => {const val: {value: string, checked: boolean} = {value: e, checked: false}; return val; });

  cronHourSpecificSpecificState: {value: string, checked: boolean}[] = this.range0To23.map(e => {const val: {value: string, checked: boolean} = {value: e, checked: false}; return val; });

  cronDowSpecificSpecificState: {label: string, value: string, checked: boolean}[] =
    [
      { label: 'Sunday', value: 'SUN', checked: false},
      { label: 'Monday', value: 'MON', checked: false},
      { label: 'Tuesday', value: 'TUE', checked: false},
      { label: 'Wednesday', value: 'WED', checked: false},
      { label: 'Thursday', value: 'THU', checked: false},
      { label: 'Friday', value: 'FRI', checked: false},
      { label: 'Saturday', value: 'SAT', checked: false},
    ];

  cronDomSpecificSpecificState: {value: string, checked: boolean}[] = this.range1To31.map(e => {const val: {value: string, checked: boolean} = {value: e, checked: false}; return val; });

  cronMonthSpecificSpecificState: {label: string, value: string, checked: boolean}[] =
    [
      { label: 'January', value: 'JAN', checked: false},
      { label: 'February', value: 'FEB', checked: false},
      { label: 'March', value: 'MAR', checked: false},
      { label: 'April', value: 'APR', checked: false},
      { label: 'May', value: 'MAY', checked: false},
      { label: 'June', value: 'JUN', checked: false},
      { label: 'July', value: 'JUL', checked: false},
      { label: 'August', value: 'AUG', checked: false},
      { label: 'September', value: 'SEP', checked: false},
      { label: 'October', value: 'OCT', checked: false},
      { label: 'November', value: 'NOV', checked: false},
      { label: 'December', value: 'DEC', checked: false},
    ];

  cronYearSpecificSpecificState: {value: string, checked: boolean}[] = this.range2020To2029.map(e => {const val: {value: string, checked: boolean} = {value: e, checked: false}; return val; });

  constructor(public fb: UntypedFormBuilder) { }

  parsePart(part: string, rs: string) {
    const re = new RegExp(rs, 'g');

    const groups: any = {};
    let output;
    while ((output = re.exec(part)) !== null) {
      Object.entries(output.groups).forEach( e => {
        const group = e[0];
        const value = e[1];
        if (value) {
          if (groups[group]) {
            if (Array.isArray(groups[group])) {
              groups[group].push(value);
            } else {
              groups[group] = [groups[group], value];
            }
          } else {
            groups[group] = value;
          }
        }
      });
    }

    return groups;
  }

  makeArray(value: any) {
    return value ? (Array.isArray(value) ? value : [value]) : [];
  }

  parseMinutes(part: string): UntypedFormGroup {
    const range0To59RE = '(?:[1-5][0-9]|[0-9])';
    const range1To60RE = '(?:[1-5][0-9]|60|[1-9])';
    const rs = `(?<all>\\*)|(?<rangestart>${range0To59RE})-(?<rangeend>${range0To59RE})|(?<incstart>${range0To59RE})\/(?<incinc>${range1To60RE})|(?<list>${range0To59RE})+,?`;
    const groups = this.parsePart(part, rs);

    this.makeArray(groups.list).forEach(e => {
      this.cronMinuteSpecificSpecificState.filter(s => s.value === e).forEach( s => s.checked = true);
    });

    const cronMinuteRadio = groups.list ? 'cronMinuteSpecific' : (groups.incinc ? 'cronMinuteIncrement' : (groups.rangestart ? 'cronMinuteRange' : 'cronEveryMinute'));

    return this.fb.group(
      {
        cronMinuteRadio: new UntypedFormControl(cronMinuteRadio),
        cronMinuteIncrementIncrement: new UntypedFormControl(groups.incinc || '1'),
        cronMinuteIncrementStart: new UntypedFormControl(groups.incstart || '0'),
        cronMinuteRangeStart: new UntypedFormControl(groups.rangestart || '0'),
        cronMinuteRangeEnd: new UntypedFormControl(groups.rangeend || '0'),
        cronMinuteSpecificSpecific: new UntypedFormControl(this.flattenValues(this.cronMinuteSpecificSpecificState)),
      });
  }

  parseHours(part: string): UntypedFormGroup {
    const range0To23RE = '(?:2[0-3]|1[0-9]|[0-9])';
    const range1To24RE = '(?:2[0-4]|1[0-9]|[1-9])';
    const rs = `(?<all>\\*)|(?<rangestart>${range0To23RE})-(?<rangeend>${range0To23RE})|(?<incstart>${range0To23RE})\/(?<incinc>${range1To24RE})|(?<list>${range0To23RE})+,?`;
    const groups = this.parsePart(part, rs);

    this.makeArray(groups.list).forEach(e => {
      this.cronHourSpecificSpecificState.filter(s => s.value === e).forEach( s => s.checked = true);
    });

    const cronHourRadio = groups.list ? 'cronHourSpecific' : (groups.incinc ? 'cronHourIncrement' : (groups.rangestart ? 'cronHourRange' : 'cronEveryHour'));

    return this.fb.group(
      {
        cronHourRadio: new UntypedFormControl(cronHourRadio),
        cronHourIncrementIncrement: new UntypedFormControl(groups.incinc || '1'),
        cronHourIncrementStart: new UntypedFormControl(groups.incstart || '0'),
        cronHourRangeStart: new UntypedFormControl(groups.rangestart || '0'),
        cronHourRangeEnd: new UntypedFormControl(groups.rangeend || '0'),
        cronHourSpecificSpecific: new UntypedFormControl(this.flattenValues(this.cronHourSpecificSpecificState)),
      });
  }

  parseDays(dom: string, dow: string, recurring: string): UntypedFormGroup {
    const rangeDaysRE = '(?:SUN|MON|TUE|WED|THU|FRI|SAT)';
    const range1To28RE = '(?:2[0-8]|1[0-9]|[1-9])';
    const range1To31RE = '(?:3[0-1]|[1-2][0-9]|[1-9])';
    const range1To7RE = '(?:[1-7])';
    const range1To5RE = '(?:[1-5])';
    const domRs = `(?<all>\\*)|(?<lastweekday>LW)|(?<nearestweekday>${range1To31RE})W|(?<lastday>L)|L-(?<minusdays>${range1To31RE})|(?<incstart>${range1To31RE})\/(?<incinc>${range1To31RE})|(?<list>${range1To31RE})+,?`;
    const dowRs = `(?<all>\\*)|(?<lastday>${range1To7RE})L|(?<nthday>${range1To7RE})#(?<nthnth>${range1To5RE})|(?<incstart>${range1To7RE})\/(?<incinc>${range1To7RE})|(?<list>${rangeDaysRE})+,?`;
    const recurringRs = `(?<all>\\*)|\@(?<recday>${range1To28RE})+,?`;
    const domGroups = this.parsePart(dom, domRs);
    const dowGroups = this.parsePart(dow, dowRs);
    const recurringGroups = this.parsePart(recurring, recurringRs);

    this.makeArray(domGroups.list).forEach(e => {
      this.cronDomSpecificSpecificState.filter(s => s.value === e).forEach( s => s.checked = true);
    });

    this.makeArray(dowGroups.list).forEach(e => {
      this.cronDowSpecificSpecificState.filter(s => s.value === e).forEach( s => s.checked = true);
    });

    let cronDayRadio = 'cronEveryDay';

    if (dowGroups.all) {
      cronDayRadio = 'cronEveryDay';
    } else if (dowGroups.incstart) {
      cronDayRadio = 'cronDowIncrement';
    } else if (domGroups.incstart) {
      cronDayRadio = 'cronDomIncrement';
    } else if (dowGroups.list) {
      cronDayRadio = 'cronDowSpecific';
    } else if (domGroups.list) {
      cronDayRadio = 'cronDomSpecific';
    } else if (domGroups.lastday) {
      cronDayRadio = 'cronLastDayOfMonth';
    } else if (domGroups.lastweekday) {
      cronDayRadio = 'cronLastWeekdayOfMonth';
    } else if (dowGroups.lastday) {
      cronDayRadio = 'cronLastSpecificDom';
    } else if (domGroups.minusdays) {
      cronDayRadio = 'cronDaysBeforeEom';
    } else if (domGroups.nearestweekday) {
      cronDayRadio = 'cronDaysNearestWeekdayEom';
    } else if (dowGroups.nthday) {
      cronDayRadio = 'cronNthDay';
    }

    return this.fb.group(
      {
        cronDayRadio: new UntypedFormControl(cronDayRadio),
        cronDowIncrementIncrement: new UntypedFormControl(dowGroups.incinc || '1'),
        cronDowIncrementStart: new UntypedFormControl(dowGroups.incstart || '1'),
        cronDomIncrementIncrement: new UntypedFormControl(domGroups.incinc || '1'),
        cronDomIncrementStart: new UntypedFormControl(domGroups.incstart || '1'),
        cronDowSpecificSpecific: new UntypedFormControl(this.flattenValues(this.cronDowSpecificSpecificState)),
        cronDomSpecificSpecific: new UntypedFormControl(this.flattenValues(this.cronDomSpecificSpecificState)),
        cronLastSpecificDomDay: new UntypedFormControl(dowGroups.lastday || '1'),
        cronDaysBeforeEomMinus: new UntypedFormControl(domGroups.minusdays || '1'),
        cronDaysNearestWeekday: new UntypedFormControl(domGroups.nearestweekday || '1'),
        cronNthDayDay: new UntypedFormControl(dowGroups.nthday || '1'),
        cronNthDayNth: new UntypedFormControl(dowGroups.nthnth || '1'),
        cronRecurringDay: new UntypedFormControl(!!recurringGroups.recday),
        cronRecurringDayIncrement: new UntypedFormControl(recurringGroups.recday || '1')
      });
  }

  parseMonths(part: string): UntypedFormGroup {
    const rangeMonthsRE = '(?:JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)';
    const range1To12RE = '(?:1[0-2]|[1-9])';
    const rs = `(?<all>\\*)|(?<rangestart>${range1To12RE})-(?<rangeend>${range1To12RE})|(?<incstart>${range1To12RE})\/(?<incinc>${range1To12RE})|(?<list>${rangeMonthsRE})+,?`;
    const groups = this.parsePart(part, rs);

    this.makeArray(groups.list).forEach(e => {
      this.cronMonthSpecificSpecificState.filter(s => s.value === e).forEach( s => s.checked = true);
    });

    const cronMonthRadio = groups.list ? 'cronMonthSpecific' : (groups.incinc ? 'cronMonthIncrement' : (groups.rangestart ? 'cronMonthRange' : 'cronEveryMonth'));

    return this.fb.group(
      {
        cronMonthRadio: new UntypedFormControl(cronMonthRadio),
        cronMonthIncrementIncrement: new UntypedFormControl(groups.incinc || '1'),
        cronMonthIncrementStart: new UntypedFormControl(groups.incstart || '1'),
        cronMonthRangeStart: new UntypedFormControl(groups.rangestart || '1'),
        cronMonthRangeEnd: new UntypedFormControl(groups.rangeend || '1'),
        cronMonthSpecificSpecific: new UntypedFormControl(this.flattenValues(this.cronMonthSpecificSpecificState)),
      });
  }

  parseYears(part: string): UntypedFormGroup {
    const rangeYearsRE = '(?:2020|2021|2022|2023|2024|2025|2026|2027|2028|2029)';
    const range1To20RE = '(?:1[0-2]|[1-9])';
    const rs = `(?<all>\\*)|(?<rangestart>${rangeYearsRE})-(?<rangeend>${rangeYearsRE})|(?<incstart>${rangeYearsRE})\/(?<incinc>${range1To20RE})|(?<list>${rangeYearsRE})+,?`;
    const groups = this.parsePart(part, rs);

    this.makeArray(groups.list).forEach(e => {
      this.cronYearSpecificSpecificState.filter(s => s.value === e).forEach( s => s.checked = true);
    });

    const cronYearRadio = groups.list ? 'cronYearSpecific' : (groups.incinc ? 'cronYearIncrement' : (groups.rangestart ? 'cronYearRange' : 'cronEveryYear'));

    return this.fb.group(
      {
        cronYearRadio: new UntypedFormControl(cronYearRadio),
        cronYearIncrementIncrement: new UntypedFormControl(groups.incinc || '1'),
        cronYearIncrementStart: new UntypedFormControl(groups.incstart || '2020'),
        cronYearRangeStart: new UntypedFormControl(groups.rangestart || '2020'),
        cronYearRangeEnd: new UntypedFormControl(groups.rangeend || '2020'),
        cronYearSpecificSpecific: new UntypedFormControl(this.flattenValues(this.cronYearSpecificSpecificState)),
      });
  }

  ngOnInit(): void {

    const parts = this.expression.split(/[ ]+/);

    this.cronForm = this.fb.group({
      cronMinute: this.parseMinutes(parts[1] || ""),
      cronHour: this.parseHours(parts[2] || ""),
      cronDay: this.parseDays(parts[3] || "", parts[5] || "", parts[7] || ""),
      cronMonth: this.parseMonths(parts[4] || ""),
      cronYear: this.parseYears(parts[6] || ""),
    });

    this.calc();
  }

  calcMinutes(): string {
    const value = this.cronForm.get('cronMinute').value;

    let minutes = '';
    if (value.cronMinuteRadio === 'cronEveryMinute') {
      minutes = "*";
    } else if (value.cronMinuteRadio === 'cronMinuteIncrement') {
      minutes = value.cronMinuteIncrementStart + '/' + value.cronMinuteIncrementIncrement;
    } else if (value.cronMinuteRadio === 'cronMinuteSpecific') {
      minutes = value.cronMinuteSpecificSpecific || '0';
    } else {
      minutes = value.cronMinuteRangeStart + '-' + value.cronMinuteRangeEnd;
    }

    return minutes;
  }

  calcHours(): string {
    const value = this.cronForm.get('cronHour').value;

    let hours = '';
    if (value.cronHourRadio === 'cronEveryHour') {
      hours = "*";
    } else if (value.cronHourRadio === 'cronHourIncrement') {
      hours = value.cronHourIncrementStart + '/' + value.cronHourIncrementIncrement;
    } else if (value.cronHourRadio === 'cronHourSpecific') {
      hours = value.cronHourSpecificSpecific || '0';
    } else {
      hours = value.cronHourRangeStart + '-' + value.cronHourRangeEnd;
    }

    return hours;
  }

  calcDays(): {dom: string, dow: string, recurring: string} {
    const value = this.cronForm.get('cronDay').value;

    let dom = '';
    let dow = '';
    let recurring = '';

    if (value.cronDayRadio === 'cronEveryDay') {
      dow = "*";
      dom = '?';
    } else if (value.cronDayRadio === 'cronDowIncrement') {
      dow = value.cronDowIncrementStart + '/' + value.cronDowIncrementIncrement;
      dom = '?';
    } else if (value.cronDayRadio === 'cronDomIncrement') {
      dom = value.cronDomIncrementStart + '/' + value.cronDomIncrementIncrement;
      dow = '?';
    } else if (value.cronDayRadio === 'cronDowSpecific') {
      dow = value.cronDowSpecificSpecific || 'SUN';
      dom = '?';
    } else if (value.cronDayRadio === 'cronDomSpecific') {
      dow = '?';
      dom = value.cronDomSpecificSpecific || '1';
    } else if (value.cronDayRadio === 'cronLastDayOfMonth') {
      dow = '?';
      dom = 'L';
    } else if (value.cronDayRadio === 'cronLastWeekdayOfMonth') {
      dow = '?';
      dom = 'LW';
    } else if (value.cronDayRadio === 'cronLastSpecificDom') {
      dow = value.cronLastSpecificDomDay + 'L';
      dom = '?';
    } else if (value.cronDayRadio === 'cronDaysBeforeEom') {
      dow = '?';
      dom = 'L-' + value.cronDaysBeforeEomMinus;
    } else if (value.cronDayRadio === 'cronDaysNearestWeekdayEom') {
      dow = '?';
      dom = value.cronDaysNearestWeekday + 'W';
    } else if (value.cronDayRadio === 'cronNthDay') {
      dow = value.cronNthDayDay + '#' + value.cronNthDayNth;
      dom = '?';
    }

    if (value.cronRecurringDay) {
      recurring = value.cronRecurringDayIncrement;
    }

    return { dom, dow, recurring };
  }

  calcMonths(): string {
    const value = this.cronForm.get('cronMonth').value;

    let months = '';
    if (value.cronMonthRadio === 'cronEveryMonth') {
      months = "*";
    } else if (value.cronMonthRadio === 'cronMonthIncrement') {
      months = value.cronMonthIncrementStart + '/' + value.cronMonthIncrementIncrement;
    } else if (value.cronMonthRadio === 'cronMonthSpecific') {
      months = value.cronMonthSpecificSpecific || '1';
    } else {
      months = value.cronMonthRangeStart + '-' + value.cronMonthRangeEnd;
    }

    return months;
  }

  calcYears(): string {
    const value = this.cronForm.get('cronYear').value;

    let years = '';
    if (value.cronYearRadio === 'cronEveryYear') {
      years = "*";
    } else if (value.cronYearRadio === 'cronYearIncrement') {
      years = value.cronYearIncrementStart + '/' + value.cronYearIncrementIncrement;
    } else if (value.cronYearRadio === 'cronYearSpecific') {
      years = value.cronYearSpecificSpecific || '2020';
    } else {
      years = value.cronYearRangeStart + '-' + value.cronYearRangeEnd;
    }

    return years;
  }


  calc() {
    const existingExpression = this.expression;
    const seconds = "0";
    const minutes = this.calcMinutes();
    const hours = this.calcHours();
    const { dom, dow, recurring } = this.calcDays();
    const months = this.calcMonths();
    const years = this.calcYears();

    let expression = [seconds, minutes, hours, dom, months, dow, years].join(' ');

    if (recurring) {
      expression = expression + " @" + recurring;
    }

    this.expression = expression;

    if (existingExpression !== this.expression) {
      this.expressionChange.emit(this.expression);
    }

  }

  onChange(event: any) {
    this.calc();
  }

  onCheckListChange(event: any, checkbox: any, state: any, groupName: string, checkboxControlName: string) {
    checkbox.checked = event.target.checked;
    this.cronForm.get(groupName).get(checkboxControlName).setValue(this.flattenValues(state));
    this.calc();
  }

  pad(value: string, width: number, prefix: string) {
    return value.padStart(width, prefix);
  }

  range(start: number, end: number): number[] {
    return Array.from({length: (end - start + 1)}, (v, k) => k + start);
  }

  stringRange(start: number, end: number): string[] {
    return this.range(start, end).map(e => '' + e);
  }

  flattenValues(checkboxes: any[]) {
    return checkboxes.filter(e => e.checked).map(e => e.value).join(',');
  }

  daySuffix(day: string) {
    let suffix = 'th';
    if (day === '1' || day === '21' || day === '31') {
      suffix = 'st';
    } else if (day === '2' || day === "22") {
      suffix = 'nd';
    } else if (day === '3' || day === '23') {
      suffix = 'rd';
    }
    return day + suffix;
  }
}
